<div class="container-fluid" style="margin-bottom : 3rem">
    <div class=" justify-content-center align-items-center min-vh-100 ">
        <!-- <div class="col-sm-8 offset-sm-2 mt-5"> -->
        <div class="card ">
            <router-outlet></router-outlet>
        </div>
        <!-- </div> -->
    </div>
</div>